// Risk styling + geo/formatting helpers shared across the dashboard.

export const RISK = {
  HIGH: {
    color: "#FF9F1C",
    hex: "#FF9F1C",
    label: "HIGH",
    text: "text-amber-400",
    ring: "border-amber-500/60",
    chip: "bg-amber-500/15 text-amber-300 border-amber-500/40",
    glow: "shadow-[0_0_16px_rgba(255,159,28,0.35)]",
  },
  MODERATE: {
    color: "#FFD166",
    hex: "#FFD166",
    label: "MODERATE",
    text: "text-yellow-200",
    ring: "border-yellow-400/40",
    chip: "bg-yellow-400/10 text-yellow-200 border-yellow-400/30",
    glow: "",
  },
  LOW: {
    color: "#22D3EE",
    hex: "#22D3EE",
    label: "LOW",
    text: "text-cyan-300",
    ring: "border-cyan-500/30",
    chip: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30",
    glow: "",
  },
  MINIMAL: {
    color: "#64748B",
    hex: "#64748B",
    label: "MINIMAL",
    text: "text-slate-400",
    ring: "border-slate-600/40",
    chip: "bg-slate-600/10 text-slate-400 border-slate-600/30",
    glow: "",
  },
};

export function riskOf(level) {
  return RISK[level] || RISK.MINIMAL;
}

// live HH:MM:SS countdown from an ISO eta string
export function countdown(etaIso) {
  const ms = new Date(etaIso).getTime() - Date.now();
  if (ms <= 0) return { text: "LANDING", over: true };
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return { text: `${pad(h)}:${pad(m)}:${pad(sec)}`, over: false };
}

// biomass green ramp 0..1 -> rgb string
export function biomassColor(t) {
  const c = Math.max(0, Math.min(1, t));
  const r = Math.round(10 + c * 20);
  const g = Math.round(120 + c * 135);
  const b = Math.round(90 + c * 30);
  return `rgb(${r},${g},${b})`;
}

// equirectangular projection into a canvas of size W x H for a given bbox
export function projector(bbox, W, H) {
  const [w, s, e, n] = bbox;
  return {
    x: (lng) => ((lng - w) / (e - w)) * W,
    y: (lat) => ((n - lat) / (n - s)) * H,
  };
}

// shift belt points westward to visualise the forecast drift at +hours
export function shiftBelt(belt, hours) {
  const dLng = -(hours / 24) * 1.1; // ~1.1 deg west per day
  return belt.map((p) => ({ ...p, lng: p.lng + dLng }));
}

export const ISLAND_PHOTO =
  "https://images.unsplash.com/photo-1782867157654-6160d2236ef0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
